import React from 'react';
import Uploader from '../../../../common/Uploader';
import DefaultUploadView from '../../../../common/uploader/DefaultUploadView';
import { TUploaderFileInfo } from '../../../../common/uploader/types';
import UploaderApi from '../../../../common/uploader/UploaderApi';

interface IFileTranslation {
  api: UploaderApi;
  file: TUploaderFileInfo;
  langId: number;
}

const FileTranslation = (props: IFileTranslation) => {
  const variantMemo = React.useMemo(
    () => ({ variant: 'layout.execution.form.fields.uploader.defaultView' }),
    [],
  );

  return (
    <Uploader
      langId={props.langId}
      id={props.api.id}
      type={props.api.type}
      Api={props.api}
      maxFiles={1}
      translatingFile={props.file}
      dropzoneId={`translate_${
        props.file.name || props.file.docName || 'noName'
      }_${props.langId}`}
    >
      <DefaultUploadView
        data-variant="layout.execution.form.fields.uploader.defaultView"
        sx={variantMemo}
      />
    </Uploader>
  );
};

export default FileTranslation;
